<template>
    <h1 style="text-align: center">
      Page404，页面不存在
    </h1>
</template>

<script>
    export default {
        name: "page404"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page404.vue